<div class="loader"></div>
<div class="loading-text">Loading...</div>